<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <h1>Customer Service & Policies</h1>
        <br />

        <!-- Customer Service Contact -->
        <el-card style="margin-bottom:20px">
          <div style="text-align:center">
            <p style="font-size:1.1rem;font-weight:600;margin-bottom:8px">{{ $t('Customer Service') }}</p>
            <p style="font-size:1.2rem;color:#4f46e5">📧 <a href="mailto:emperinter@outlook.com">emperinter@outlook.com</a></p>
            <p style="color:#94a3b8;font-size:0.875rem;margin-top:8px">{{ $t('Contact Hint') }}</p>
          </div>
        </el-card>

        <!-- Refund Policy -->
        <el-collapse v-model="activePanels">
          <el-collapse-item title="refund" :name="'refund'">
            <template #title>
              <span style="font-size:1.1rem;font-weight:600">{{ $t('Refund Policy') }}</span>
            </template>
            <el-card>
              <ul class="svc-list">
                <li>{{ $t('refund_policy_1') }}</li>
                <li>{{ $t('refund_policy_2') }}</li>
                <li>{{ $t('refund_policy_3') }}</li>
              </ul>
            </el-card>
          </el-collapse-item>

          <el-collapse-item :name="'tos'">
            <template #title>
              <span style="font-size:1.1rem;font-weight:600">{{ $t('Terms of Service') }}</span>
            </template>
            <el-card>
              <!-- Pricing & Billing -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('tos_pricing_title') }}</h3>
              <ul class="svc-list" style="margin-bottom:16px">
                <li>{{ $t('tos_pricing_1') }}</li>
                <li>{{ $t('tos_pricing_2') }}</li>
                <li>{{ $t('tos_pricing_3') }}</li>
              </ul>

              <!-- Refund Policy (restated) -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('tos_refund_title') }}</h3>
              <ul class="svc-list" style="margin-bottom:16px">
                <li>{{ $t('tos_refund_1') }}</li>
                <li>{{ $t('tos_refund_2') }}</li>
              </ul>

              <!-- Disclaimer -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('tos_disclaimer_title') }}</h3>
              <ul class="svc-list" style="margin-bottom:16px">
                <li>{{ $t('tos_disclaimer_1') }}</li>
                <li>{{ $t('tos_disclaimer_2') }}</li>
                <li>{{ $t('tos_disclaimer_3') }}</li>
                <li>{{ $t('tos_disclaimer_4') }}</li>
              </ul>

              <!-- User Liability -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('tos_user_liability_title') }}</h3>
              <ul class="svc-list" style="margin-bottom:16px">
                <li>{{ $t('tos_user_liability_1') }}</li>
                <li>{{ $t('tos_user_liability_2') }}</li>
                <li>{{ $t('tos_user_liability_3') }}</li>
              </ul>

              <!-- Governing Law -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('tos_governing_law_title') }}</h3>
              <ul class="svc-list">
                <li>{{ $t('tos_governing_law_1') }}</li>
              </ul>
            </el-card>
          </el-collapse-item>

          <el-collapse-item :name="'privacy'">
            <template #title>
              <span style="font-size:1.1rem;font-weight:600">{{ $t('Privacy Policy') }}</span>
            </template>
            <el-card>
              <!-- Data Collection -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('privacy_collection_title') }}</h3>
              <ul class="svc-list" style="margin-bottom:16px">
                <li>{{ $t('privacy_collection_1') }}</li>
                <li>{{ $t('privacy_collection_2') }}</li>
                <li>{{ $t('privacy_collection_3') }}</li>
                <li>{{ $t('privacy_collection_4') }}</li>
              </ul>

              <!-- User Rights -->
              <h3 style="font-weight:600;margin:0 0 8px">{{ $t('privacy_rights_title') }}</h3>
              <ul class="svc-list">
                <li><strong>{{ $t('privacy_rights_access') }}</strong>{{ $t('privacy_rights_access_desc') }}</li>
                <li><strong>{{ $t('privacy_rights_correct') }}</strong>{{ $t('privacy_rights_correct_desc') }}</li>
                <li><strong>{{ $t('privacy_rights_delete') }}</strong>{{ $t('privacy_rights_delete_desc') }}</li>
              </ul>
              <p style="margin-top:12px;padding-top:12px;border-top:1px solid #e2e8f0;color:#6b7280">{{ $t('privacy_rights_contact') }} <a href="mailto:emperinter@outlook.com">emperinter@outlook.com</a></p>
            </el-card>
          </el-collapse-item>
        </el-collapse>

        <!-- Contact -->
        <el-card style="margin-top:20px;text-align:center">
          <p style="color:#4b5563">{{ $t('Contact Bottom') }} <a href="mailto:emperinter@outlook.com" style="color:#4f46e5;font-weight:600">emperinter@outlook.com</a></p>
        </el-card>

        <p style="text-align:center;color:#9ca3af;margin-top:20px">
          Copyright © {{ currentYear }} emperinter
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO'

export default {
  name: 'ServiceComponent',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      activePanels: ['refund', 'tos', 'privacy']
    }
  },
  mounted() {
    useSEO({
      title: 'Customer Service — WordCloudStudio',
      description: 'WordCloudStudio refund policy, terms of service, and privacy policy. Contact us at emperinter@outlook.com.',
      keywords: 'wordcloudstudio refund, terms of service, privacy policy, word cloud support, contact',
      canonical: '/service',
      ogTitle: 'Customer Service & Policies — WordCloudStudio',
      ogDescription: 'Refund policy, terms of service, privacy policy, and contact information for WordCloudStudio.',
      ogImage: 'https://wordcloudstudio.com/wcdw.png',
      twitterTitle: 'Customer Service — WordCloudStudio',
      twitterDescription: 'Refund policy, terms of service, and privacy policy for WordCloudStudio.',
      twitterImage: 'https://wordcloudstudio.com/wcdw.png'
    })
  }
}
</script>

<style scoped>
ul.svc-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
ul.svc-list li {
  position: relative;
  padding: 0.4rem 0 0.4rem 1.5rem;
  color: #4b5563;
  line-height: 1.65;
  text-align: left;
}
ul.svc-list li::before {
  content: '•';
  position: absolute;
  left: 0.25rem;
  color: #818cf8;
  font-weight: bold;
}
li {
  text-align: left;
}
</style>
